export const LOCAL_STORAGE_KEY_UPDATE_OLD_CREDENTIALS = 'riseup.update_old_creds_page';

export const SUBSCRIPTION_STATES = {
  TRIAL: 'trial',
  FREE: 'free',
  SUBSCRIBED: 'subscribed',
  DORMANT_AFTER_CANCELED: 'dormant-after-canceled',
  DORMANT_AFTER_TRIAL: 'dormant-after-trial',
  CANCELED: 'canceled',
  PRE_TRIAL: 'pre-trial',
};

export const SUBSCRIPTION_TYPES = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};
